<bmcore-producer-page-header [producer]="producer" [userID]="userID" [appType]="appType"> </bmcore-producer-page-header>

<div class="common-container">
  <!-- Tracks -->
  <div class="beatmaker-page__tracks">
    <h2 class="common-section-title">
      {{ lg.tracksBlock.heading }}
    </h2>
    @if (!!beatmakerId) {
      <bmcore-tracks-block
        [appType]="appType"
        [isTracksPage]="false"
        [isShowTracksAllBeatmakers]="false"
        [pageSize]="10"
        [producerId]="beatmakerId"
        [beatmakerId]="beatmakerId"
        [pagesWithFilter]="'no-filter'"
        [currentSortById]="BeatsSortBy.OrderNumber"
        [showVerificationIcon]="true"
      >
      </bmcore-tracks-block>
    }
  </div>

  <!-- License info -->
  <div class="beatmaker-page__license">
    <p class="common-section-title">{{ lg.producerPage.licenseBlock }}</p>
    <bmcore-license-slider
      [licenses]="licenses"
      [licenseBulkDiscounts]="licenseBulkDiscounts"
      [btnInLicenseName]="'to beat list'"
      [toBeatListBtnRoute]="'catalog'"
    >
    </bmcore-license-slider>
  </div>

  <!-- Contacts -->
  <div class="beatmaker-page__contacts">
    <bmcore-contacts-block
      [appType]="appType"
      [beatmakerName]="producer?.beatmakerName"
      [beatmakerId]="producer?.beatmakerId"
      [emailSecret]="producer?.emailSecret"
      [socialContacts]="producer?.contacts"
      [sourceType]="sourceType"
      [BMTVContacts]="BMTVContacts"
    >
    </bmcore-contacts-block>
  </div>
</div>
